<template>
  <div class="page">
    <!-- formTop start -->
    <div class="formTop">
      <span class="tab" :class="{act:menuSelindex==0}" @click="changeLoginType(0)">读者账号认证 <em class="line">&nbsp;</em></span>
      <span class="tab" :class="{act:menuSelindex==1}" @click="changeLoginType(1)">校友认证</span>
    </div>
    <!-- formTop end -->

    <!-- formPanels start -->
    <div class="formPanels">
      <!-- 个人 -->
      <div v-show="menuSelindex==0" class="panel">
        <div class="ipt" :class="accountError?'err':''"><!-- 读者证账号 -->
          <input v-model="readerAccount" type="text" placeholder="请输入读者证/学号">
        </div>
        <div v-if="accountError" class="err-tip">请输入正确的账号/学号</div><!-- 读者证账号错误提示 -->

        <div class="ipt" :class="passwordError?'err':''">
          <input v-model="readerPassword" type="text" placeholder="请输入密码">
        </div>
        <div v-if="passwordError" class="err-tip">输入正确的密码</div> <!-- 密码错误提示 -->
      </div>

      <!-- 团体 -->
      <div v-show="menuSelindex==1" class="panel">
        <div class="ipt" :class="userNameError?'err':''"><!-- 姓名 -->
          <input v-model="realName" type="text" placeholder="请输入真实姓名">
        </div>
        <div v-if="accountError" class="err-tip">请输入正确的姓名</div>

        <div class="ipt" :class="userIDNumberError?'err':''"><!-- 身份证 -->
          <input v-model="personId" type="text" placeholder="请输入身份证号码">
        </div>
        <!-- <div v-if="passwordError"  class="err-tip"  v-if="accountError">请输入正确的身份证号</div> -->

        <div class="ipt" :class="userIDNumberError?'err':''"><!-- 日期 -->
          <el-date-picker v-model="inTime" value-format="yyyy" type="year" size="normal" data-id="year" :clearable="false" placeholder="请选择入学年份" />
        </div>
        <!-- <div class="err-tip">日期错误</div> -->
      </div>

      <div class="form-btns">
        <button type="button" class="btn-blue" @click="toAuth">立即认证</button>
        <div class="btn-skip">
          <a href="javascript:;" class="skip" @click="skipAuth">跳过，稍后认证</a>
        </div>
      </div>
    </div>
    <!-- formPanels end -->
  </div>
</template>
<script>
import api from '../../../api/auth.js'
import user from '../../../models/user.js'
export default {
  name: 'Wapidentify',
  data() {
    return {
      menuSelindex: 0,
      accountError: false,
      passwordError: false,
      userNameError: false,
      userIDNumberError: false,
      cominScollDate: '',

      canSkip: false,

      readerAccount: null,
      readerPassword: null,

      realName: null,
      personId: null,
      inTime: null,

      redirectUrl: ''
    }
  },
  created() {
    this.redirectUrl = this.$route.query.r || '/'
    this.canSkip = this.$route.query.skip !== 'n'
  },
  methods: {
    changeLoginType(t) {
      this.menuSelindex = t
    },
    toAuth() {
      if (this.menuSelindex === 0) {
        const that = this
        const params = {
          readerAccount: that.readerAccount,
          readerPassword: that.readerPassword
        }

        api.readerAuth(params).then(r => {
          that.$router.push({ path: that.redirectUrl })
          user.updateUser()
        }).catch(error => {
          that.$refs.authfail.showauthfail(error.message)
          alert(error + '请联系客服人员')
        })
      } else {
        const params = {
          alumnusName: this.realName,
          alumnusNumber: this.personId,
          alumnusYear: this.inTime
        }
        const that = this
        api.schoolAuth(params).then(r => {
          that.$router.push({ path: that.redirectUrl })
          user.updateUser()
        }).catch(error => {
          alert(error.message + '请联系客服人员')
        })
      }
    },
    inputChange(v) {
      const type = v.currentTarget.dataset.typ
      const value = v.target.value
      if (type === 'account') {
        this.readerAccount = value
      } else if (type === 'password') {
        this.readerPassword = value
      } else if (type === 'name') {
        this.realName = value
      } else if (type === 'personid') {
        this.personId = value
      }
    },
    skipAuth() {
      const that = this
      console.log('that.redirectUrl',that.redirectUrl)
      this.$router.push({
        path: that.redirectUrl=='/wap/user'?that.redirectUrl+'?act=skip':that.redirectUrl=='/wap/upload'?that.redirectUrl:that.redirectUrl+'&act=skip'
      })
    }
  }
}
</script>
<style src="@/styles/wap.scss" lang="scss" scoped></style>
<style scoped>
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width:100%
}
</style>
